import React from 'react';
import { FocusOn } from 'react-focus-on';
import Button from '../../../Buttons/Button';
import { useTranslation } from 'react-i18next';
import { PRIVACY_POLICY_LINK } from '../../../../constants';
import './CookieBanner.scss';

const CookieBanner = ({ acceptCookiePolicy, showCookieBanner }) => {
  const { t } = useTranslation();
  return (
    <FocusOn enabled={showCookieBanner}>
      <div
        id="cookie-banner"
        className="cookie-banner"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cookie-policy-label"
      >
        <div className="text-container">
          <h2 id="cookie-policy-label" className="subheader-1">
            {t('publicTour.cookies.header')}
          </h2>
          <p className="subheader-2">
            {t('publicTour.cookies.description')}
            &nbsp;
            <a
              href={PRIVACY_POLICY_LINK}
              target="_black"
              className="policy-link"
              rel="noopener noreferrer"
            >
              {t('publicTour.cookies.learnMore')}
            </a>
          </p>
        </div>

        <Button
          handleClick={acceptCookiePolicy}
          className="accept-btn"
          data-cy="privacy-policy__accept-btn"
        >
          <i aria-hidden="true" className="material-icons">
            check
          </i>{' '}
          {t('publicTour.cookies.acceptButton')}
        </Button>
      </div>
    </FocusOn>
  );
};

export default CookieBanner;
